module.exports = __webpack_public_path__ + "media/images/cancel-expand-daa118525ca6e85100c3dff0c38583c0.svg";